import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';
import { ButtonColors, ButtonType, ButtonStyle, ButtonSize, ButtonActionType } from './button.model';
import { faPlus, faMinus } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss']
,  standalone: false
})
export class ButtonComponent implements OnInit {

  @Input() btnText: string = "";
  @Input() btnActionType: ButtonActionType = ButtonActionType.Submit;
  @Input() btnType: ButtonType = ButtonType.Rectangle;
  @Input() btnStyle: ButtonStyle = ButtonStyle.Textonly;
  @Input() btnColor: ButtonColors = ButtonColors.Default;
  @Input() btnSize: ButtonSize = ButtonSize.Medium;
  @Input() isDisabled: boolean = false;
  @Output() btnClick: EventEmitter<any> = new EventEmitter();

  faPlus = faPlus;
  faMinus = faMinus;
  btnClasses: string = "";

  ngOnInit() {
    this.configureButton();
  }
  configureButton() {
    switch (this.btnType) {
      case ButtonType.Rectangle: this.btnClasses = "btn-rectangle"; break;
      case ButtonType.Round: this.btnClasses = "btn-round"; break;
      default:
        this.btnClasses = "btn-rectangle";
    }
    switch (this.btnColor) {
      case ButtonColors.Blue: this.btnClasses = this.btnClasses.concat(" blue"); break;
      case ButtonColors.Yellow: this.btnClasses = this.btnClasses.concat(" yellow"); break;
      case ButtonColors.Red: this.btnClasses = this.btnClasses.concat(" red"); break;
      case ButtonColors.White: this.btnClasses = this.btnClasses.concat(" white"); break;
      case ButtonColors.Default: this.btnClasses = this.btnClasses.concat(" blue"); break;
      default: this.btnClasses = this.btnClasses.concat(" blue");
    }
    switch (this.btnSize) {
      case ButtonSize.Small: this.btnClasses = this.btnType == ButtonType.Rectangle ? this.btnClasses.concat(" rect-small") : this.btnClasses.concat(" rnd-small");
        break;
      case ButtonSize.Medium: this.btnClasses = this.btnType == ButtonType.Rectangle ? this.btnClasses.concat(" rect-medium") : this.btnClasses.concat(" rnd-medium");
        break;
      case ButtonSize.Large: this.btnClasses = this.btnType == ButtonType.Rectangle ? this.btnClasses.concat(" rect-large") : this.btnClasses.concat(" rnd-large");
        break;
      case ButtonSize.Xlarge: this.btnClasses = this.btnType == ButtonType.Rectangle ? this.btnClasses.concat(" rect-xlarge") : this.btnClasses.concat(" rnd-xlarge");
        break;
      default:
        ButtonType.Rectangle ? this.btnClasses.concat(" rect-medium") : this.btnClasses.concat(" rnd-medium");
    }
  }
  handleClick() {
    this.btnClick.emit("Clicked");
  }

}
